import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Lock, Mail, LogIn, AlertCircle } from "lucide-react";
import { apiPost, setToken } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const r = await apiPost("/auth/login", { email, password });
      setToken(r.token);
      const dest = loc.state?.from?.pathname || "/admin";
      nav(dest, { replace: true });
    } catch (ex) {
      setErr(ex.message || "Login fehlgeschlagen");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden"
      style={{ background: "linear-gradient(135deg, #020617 0%, #0f172a 50%, #064e3b 100%)" }}>
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-emerald-400/15 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-emerald-600/10 rounded-full blur-3xl pointer-events-none" />

      <div className="relative z-10 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-400 to-emerald-600 shadow-lg shadow-emerald-500/40 mb-4">
            <Lock className="w-7 h-7 text-white" />
          </div>
          <h1 className="text-3xl font-extrabold text-white font-[Outfit] mb-2">Admin Bereich</h1>
          <p className="text-slate-400 text-sm">Thermomix Krefeld · Content Management</p>
        </div>

        <form onSubmit={submit} className="rounded-2xl p-7 backdrop-blur-xl bg-white/5 border border-white/10 shadow-2xl space-y-5"
          data-testid="admin-login-form">
          <div>
            <label className="block text-xs font-bold uppercase tracking-[0.15em] text-slate-300 mb-2">E-Mail</label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-login-email"
                className="w-full pl-10 pr-4 py-3 rounded-xl bg-slate-900/60 border border-white/10 text-white placeholder-slate-500 focus:border-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/30 transition"
                placeholder="jennifer-laak@gmx.de"
              />
            </div>
          </div>

          <div>
            <label className="block text-xs font-bold uppercase tracking-[0.15em] text-slate-300 mb-2">Passwort</label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input
                type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-login-password"
                className="w-full pl-10 pr-4 py-3 rounded-xl bg-slate-900/60 border border-white/10 text-white placeholder-slate-500 focus:border-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/30 transition"
                placeholder="••••••••"
              />
            </div>
          </div>

          {err && (
            <div className="flex items-start gap-2 p-3 rounded-xl bg-red-500/10 border border-red-500/30 text-red-300 text-sm" data-testid="admin-login-error">
              <AlertCircle className="w-4 h-4 shrink-0 mt-0.5" />
              <span>{err}</span>
            </div>
          )}

          <button
            type="submit" disabled={busy}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 py-3.5 rounded-xl bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-400 hover:to-emerald-500 text-white font-bold transition-all shadow-lg shadow-emerald-500/30 disabled:opacity-50 disabled:cursor-not-allowed">
            {busy ? "Wird geprüft …" : (<><LogIn className="w-4 h-4" /> Anmelden</>)}
          </button>
        </form>

        <p className="text-center text-xs text-slate-500 mt-6">
          <a href="/" className="hover:text-emerald-400 transition">← Zurück zur Website</a>
        </p>
      </div>
    </div>
  );
}
